import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { useEffect } from "react"

import PendingComponent from "@/globalComponents/atoms/PendingComponent"
import { cleanEmptyParams } from "@/utilities/etc"
import { confirmSetupIntentQueryOptions } from "@/utilities/hooks/queries/payment"

export const Route = createFileRoute(
  "/qr/$qrLookupID/gated/register/$sessionID/payment-status"
)({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    setup_intent?: string
    setup_intent_client_secret?: string
    redirect_status?: string
  } => {
    return cleanEmptyParams({
      setup_intent: (search.setup_intent as string) || "",
      setup_intent_client_secret:
        (search.setup_intent_client_secret as string) || "",
      redirect_status: (search.redirect_status as string) || "",
    })
  },
  beforeLoad: async ({ params, search }) => {
    if (
      !search.setup_intent ||
      !search.setup_intent_client_secret ||
      search.redirect_status !== "succeeded"
    ) {
      throw redirect({
        to: "/qr/$qrLookupID/gated/register/$sessionID/checkout",
        params: { qrLookupID: params.qrLookupID, sessionID: params.sessionID },
        search: { paymentStatus: "failed" },
        replace: true,
      })
    }
  },
  component: () => <RouteComponent />,
})

function RouteComponent() {
  const { sessionID, qrLookupID } = Route.useParams()
  const navigate = Route.useNavigate()

  const { data } = useSuspenseQuery(
    confirmSetupIntentQueryOptions({ sessionID })
  )

  useEffect(() => {
    navigate({
      to: "/qr/$qrLookupID/gated/register/$sessionID/confirmation",
      params: { qrLookupID, sessionID },
      search: { key: data.confirmationKey },
      replace: true,
    })
  }, [data])

  return <PendingComponent />
}
